import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SelectableLinksDirective } from './selectableLinks.directive';

@NgModule({
  declarations: [SelectableLinksDirective],
  imports: [CommonModule],
  exports: [SelectableLinksDirective]
})
export class SelectableLinksModule {}
